var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"text-center"},[_c('div',{staticClass:"text-h6 error--text mb-2"},[_vm._v(_vm._s(_vm.errorText))]),(_vm.retryFunction)?_c('v-btn',{attrs:{"color":"secondary"},on:{"click":_vm.retryFunction}},[_vm._v("Reintentar")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }